import {
    STOCK_TAKING_CAR_MANAGEMENT_DETAILS_DATA_MASTER_BEGIN,
    STOCK_TAKING_CAR_MANAGEMENT_DETAILS_DATA_MASTER_SUCCESS,
    STOCK_TAKING_CAR_MANAGEMENT_DETAILS_DATA_MASTER_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    
    switch (action.type) {
      case STOCK_TAKING_CAR_MANAGEMENT_DETAILS_DATA_MASTER_BEGIN:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getCarDetailDataMasterPending: true,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                carDetails: null,
                carDetailsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_DETAILS_DATA_MASTER_SUCCESS:
        const stateSaveData = state.takingCarManagement.fastStockLoading.saveData
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getCarDetailDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                saveData: {
                  ...state.takingCarManagement.fastStockLoading.saveData,
                  TRANSMI: action.data.TRANSMI,
                  COMBU: stateSaveData.COMBU !== 'GNC' ? action.data.COMBU : stateSaveData.COMBU
                },
                carDetails: action.data,
                carDetailsError: null,
                savedForm: true
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_DETAILS_DATA_MASTER_FAILURE:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getCarDetailDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                carDetails: null,
                carDetailsError: action.data.error
            }
          }
        }
      default:
        return state
    }
  }
  